import React, { useState } from "react";
import { useSnackbar } from "notistack";

import api from "/imports/api/client";
import useFetch from "/imports/hooks/useFetch";
import { DataView } from "/imports/ui/components/shared";
import PreferencesEditForm from "./PreferencesEditForm";
import PreferencesSummary from "./PreferencesSummary";

// Read-only by default; the Edit button reveals the form, and a successful save
// (or Cancel) returns to the summary. Save bumps the parent's reloadKey, which
// remounts this with fresh data so the summary reflects what was just saved.
function PreferencesEditor({ slug, initial, onSaved }) {
  const { enqueueSnackbar } = useSnackbar();
  const [editing, setEditing] = useState(false);

  const handleSaved = () => {
    enqueueSnackbar("Preferences saved.", { variant: "success" });
    setEditing(false);
    onSaved?.();
  };

  if (editing) {
    return <PreferencesEditForm slug={slug} initial={initial} onCancel={() => setEditing(false)} onSaved={handleSaved} />;
  }
  return <PreferencesSummary data={initial} onEdit={() => setEditing(true)} />;
}

function PreferencesTab({ slug, reloadKey, onSaved }) {
  const { data, loading, error } = useFetch(() => api.getUserPreferences(slug), [slug, reloadKey], { skip: !slug });

  return (
    <DataView loading={loading} error={error} data={data} loadingMessage="Loading preferences...">
      {data && (
        <PreferencesEditor
          slug={slug}
          key={reloadKey}
          initial={{ ...(data.preferences || {}), birthDate: data.birthDate || "", whatsappConsent: data.whatsappConsent || "unknown" }}
          onSaved={onSaved}
        />
      )}
    </DataView>
  );
}

export default PreferencesTab;
